import { removerAcentos } from '../texto/busca-sem-acento';

/**
 * Cor de cada classe de veículo — regra única (at-130, 23/10/2026).
 *
 * As cores são as que o sistema já usava: o badge `.ClasseDoCarroPreenchido.<Classe>` do card
 * da Home (`views/home/pages/home.css`) e os ícones `img/car-*.svg`. Diretoria não tinha classe
 * CSS; a cor é a do `car-diretoria.svg`.
 *
 * ⚠️ Aceita os dois formatos da classe, como o `CarClassIcon` (at-75): o rótulo de exibição
 * ("Carros Atual", que é o que `GET /cars` e `GET /cars/:id` devolvem) e o enum cru
 * (`CARROS_ATUAL`). Classe desconhecida cai num cinza neutro — nunca na cor de outra classe.
 *
 * ⚠️ Carros Externos e Diretoria são quase o mesmo vermelho. A colisão já existia no sistema
 * e foi mostrada ao Victor em 22/10/2026, que não pediu troca.
 */

export interface CorDaClasse {
  fundo: string;
  texto: string;
}

const CORES: Record<string, CorDaClasse> = {
  ASSOCIADO: { fundo: '#ea5d0e', texto: '#ffffff' },
  TERCEIRO: { fundo: '#0062f4', texto: '#ffffff' },
  MOBI: { fundo: '#0b6130', texto: '#ffffff' },
  CARROS_EXTERNOS: { fundo: '#dc0000', texto: '#ffffff' },
  CARROS_ATUAL: { fundo: '#1a1c1b', texto: '#ffffff' },
  MOTO: { fundo: '#fc5c03', texto: '#ffffff' },
  AIRO_CLUBE: { fundo: '#ffa10a', texto: '#2b2100' },
  PERDA_TOTAL: { fundo: '#6d340c', texto: '#ffffff' },
  DIRETORIA: { fundo: '#ff0a0a', texto: '#ffffff' },
};

export const CLASSES_DE_VEICULO: Array<{ chave: string; nome: string }> = [
  { chave: 'ASSOCIADO', nome: 'Associado' },
  { chave: 'TERCEIRO', nome: 'Terceiro' },
  { chave: 'MOBI', nome: 'Mobi' },
  { chave: 'CARROS_EXTERNOS', nome: 'Carros Externos' },
  { chave: 'CARROS_ATUAL', nome: 'Carros Atual' },
  { chave: 'MOTO', nome: 'Moto' },
  { chave: 'AIRO_CLUBE', nome: 'Airo Clube' },
  { chave: 'PERDA_TOTAL', nome: 'Perda Total' },
  { chave: 'DIRETORIA', nome: 'Diretoria' },
];

export const COR_DESCONHECIDA: CorDaClasse = { fundo: '#64748b', texto: '#ffffff' };

/** "Carros Atual" → "CARROS_ATUAL"; "CARROS_ATUAL" → "CARROS_ATUAL". */
export function chaveDaClasse(classe?: string | null): string {
  if (!classe) return '';
  return removerAcentos(classe)
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_');
}

export function corDaClasse(classe?: string | null): CorDaClasse {
  return CORES[chaveDaClasse(classe)] ?? COR_DESCONHECIDA;
}

export function nomeDaClasse(classe?: string | null): string {
  const chave = chaveDaClasse(classe);
  return CLASSES_DE_VEICULO.find((c) => c.chave === chave)?.nome ?? (classe || 'Sem classe');
}
